import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { BRAND_NAME, bookingUrl, navItems } from '../data/site';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);
  return <>
    <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ease-calm ${scrolled ? 'border-b border-sand-dark/40 bg-ivory/90 backdrop-blur-md' : 'border-b border-transparent bg-gradient-to-b from-ocean-deep/45 to-transparent'}`} data-id="element-114" data-mp="36aih4z15wzd7">
      <div className="mx-auto flex h-[72px] max-w-[1400px] items-center justify-between px-5 sm:px-8 lg:h-20 lg:px-12" data-id="element-115" data-mp="2wlmbrn1xqko4">
        <a href="#home" className={`font-serif text-xl leading-none tracking-[0.18em] transition-colors duration-500 sm:text-2xl ${scrolled ? 'text-forest-deep' : 'text-ivory'}`} data-id="element-116" data-mp="2rnuhwnhqcoha">
          {BRAND_NAME}
        </a>

        <nav aria-label="Primary" className="hidden lg:block" data-id="element-117" data-mp="3fa0yhy57zcj4">
          <ul className="flex items-center gap-9" data-id="element-118" data-mp="3acj0h2sqqhpw">
            {navItems.map(item => <li key={item.label} data-id="element-119" data-mp="35lj01nkexhin">
                <a href={item.href} className={`group relative text-[12px] font-medium uppercase tracking-[0.16em] transition-colors duration-300 ${scrolled ? 'text-forest-deep/75 hover:text-forest-deep' : 'text-ivory/85 hover:text-ivory'}`} data-id="element-120" data-mp="35khh6wx5nqqd">
                  {item.label}
                  <span className="absolute -bottom-1.5 left-0 h-px w-0 bg-gold transition-all duration-300 ease-calm group-hover:w-full" data-id="element-121" data-mp="1rew8aj4c8tro" />
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="flex items-center gap-3" data-id="element-122" data-mp="1hni25shvsvpk">
          <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className={`hidden rounded-full px-6 py-3 text-[11px] font-semibold uppercase tracking-[0.18em] transition-all duration-300 ease-calm sm:inline-block ${scrolled ? 'bg-ocean text-ivory hover:bg-ocean-deep' : 'bg-ivory/95 text-forest-deep hover:bg-ivory'} hover:-translate-y-0.5 hover:shadow-lift`} data-id="element-123" data-mp="1mm317oled9cf">
            Book your stay
          </a>

          <button type="button" onClick={() => setMenuOpen(true)} aria-label="Open menu" className={`rounded-full border p-2.5 transition-colors lg:hidden ${scrolled ? 'border-forest-deep/20 text-forest-deep' : 'border-ivory/40 text-ivory'}`} data-id="element-124" data-mp="2t3gcs0spjpsw">
            <Menu className="h-5 w-5" data-id="element-125" data-mp="w4zifg7uox4g" />
          </button>
        </div>
      </div>
    </header>

    <AnimatePresence data-id="element-126" data-mp="rd7rv5op2reb">
        {menuOpen && <motion.div className="fixed inset-0 z-[60] bg-forest-deep lg:hidden" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-127" data-mp="rcg9iwk3yq5z">
            <div className="flex h-[72px] items-center justify-between px-5 sm:px-8" data-id="element-128" data-mp="1f3lnf66hn8dn">
              <span className="font-serif text-xl tracking-[0.18em] text-ivory" data-id="element-129" data-mp="1a3pjf6xsjgy3">
                {BRAND_NAME}
              </span>
              <button type="button" onClick={() => setMenuOpen(false)} aria-label="Close menu" className="rounded-full border border-ivory/30 p-2.5 text-ivory" data-id="element-130" data-mp="3gvhxebd0ca6b">
                <X className="h-5 w-5" data-id="element-131" data-mp="2311evqgmpzjq" />
              </button>
            </div>

            <nav aria-label="Mobile" className="px-5 pt-8 sm:px-8" data-id="element-132" data-mp="27vxbz50q3d3p">
              <ul className="space-y-1" data-id="element-133" data-mp="2cxwfcewgqa0n">
                {navItems.map((item, i) => <motion.li key={item.label} initial={{
              opacity: 0,
              y: 12
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.05 + i * 0.05,
              duration: 0.4
            }} data-id="element-134" data-mp="2gyq3989wnotj" data-mpi={i}>
                    <a href={item.href} onClick={() => setMenuOpen(false)} className="block border-b border-ivory/10 py-4 font-serif text-3xl text-ivory" data-id="element-135" data-mp="1t8vq0ploby8r">
                      {item.label}
                    </a>
                  </motion.li>)}
              </ul>

              <a href={bookingUrl} target="_blank" rel="noopener noreferrer" onClick={() => setMenuOpen(false)} className="mt-10 block rounded-full bg-gold px-6 py-4 text-center text-[12px] font-semibold uppercase tracking-[0.18em] text-forest-deep" data-id="element-136" data-mp="15hgk6muouysr">
                Book your stay
              </a>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </>;
}